import React, { useEffect, useRef } from 'react';

interface CanvasTableProps {
  imagePath: string;
  className?: string;
}

const CanvasTable: React.FC<CanvasTableProps> = ({ imagePath, className }) => {
  const canvasRef = useRef<HTMLCanvasElement>(null);

  useEffect(() => {
    const canvas = canvasRef.current;
    if (!canvas) return;

    const ctx = canvas.getContext('2d');
    if (!ctx) return;

    const img = new Image();
    img.src = imagePath;
    img.onload = () => {
      canvas.width = img.width;
      canvas.height = img.height;
      ctx.drawImage(img, 0, 0, img.width, img.height);
    };
  }, [imagePath]);

  return <canvas ref={canvasRef} className={className} />;
};

export default CanvasTable;